import { jsx as _jsx } from "react/jsx-runtime";
import _classCallCheck from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import style from './Icon.module.css';

var Icon = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var type = this.props.type;
      var imgName = type.replace('_', '-');
      var imgSrc = '/images/components/icon/' + imgName + '.svg';
      return /*#__PURE__*/_jsx("i", {
        className: "".concat(style.container, " ").concat(style[type], " ").concat(this.props.size ? style['size_' + this.props.size] : '', " ").concat(this.props.useImgTag ? style.useImgTag : ''),
        children: this.props.useImgTag && /*#__PURE__*/_jsx("img", {
          src: imgSrc,
          alt: type
        })
      });
    }
  }]);

  return Icon;
}(Component);

export { Icon as default };